export default "__VITE_ASSET__nxmNwR02__"